export class DateUtils {
  /**
   * Converts from Symass Date to Date format
   *
   * @param symassDate date as string in Symass Date format
   */
  public static convertFromISODate(symassDate: any): Date {
    let day: string;
    let month: string;
    let year: string;

    // Symass date is in format YYYY-MM-DD
    year = symassDate.substring(0, 4);
    month = symassDate.substring(5, 7);
    day = symassDate.substring(8);

    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  /**
   * Converts from Date to Symass Date
   *
   */
  public static convertToISODate(date: any): string | null {
    if (date === null || date === undefined) {
      return null;
    }

    let day: number;
    let month: number;
    let year: number;

    if (date instanceof Date) {
      day = date.getDate();
      month = date.getMonth() + 1;
      year = date.getFullYear();
    } else if (date.year !== undefined && date.month !== undefined && date.day !== undefined) {
      // NgbDateStruct: { year, month, day }
      day = date.day;
      month = date.month;
      year = date.year;
    } else {
      return null;
    }

    return (
      year +
      '-' +
      this.convertToTwoDigitStringNumber(month) +
      '-' +
      this.convertToTwoDigitStringNumber(day)
    );
  }

  private static convertToTwoDigitStringNumber(number: number): string {
    if (number >= 10) {
      return '' + number;
    }
    return '0' + number;
  }
}
